import { IInputTheme } from './types';
import { Colors } from '@unfold/theme';

export const InputTheme: IInputTheme = {
  default: {
    light: {
      backgroundColor: Colors.G800,
      color: Colors.BLACK,
      borderRadius: '6px',
      fontSize: '14px',
      border: 'none',
      padding: '0 15px',
    },
    dark: {
      backgroundColor: Colors.G100,
      color: Colors.WHITE,
      borderRadius: '6px',
      fontSize: '14px',
      border: 'none',
      padding: '0 15px',
    },
  },
  bordered: {
    light: {
      backgroundColor: 'transparent',
      color: Colors.BLACK,
      borderRadius: '6px',
      fontSize: '14px',
      border: `2px solid ${Colors.G600}`,
      padding: '0 15px',
    },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.G600,
      borderRadius: '6px',
      fontSize: '14px',
      border: `2px solid ${Colors.G600}`,
      padding: '0 15px',
    },
  },
  none: {
    light: {
      backgroundColor: 'transparent',
      color: Colors.BLACK,
      fontSize: '14px',
    },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.G600,
      fontSize: '14px',
    },
  }
};
